import { ServiceCode } from '../../../../../../common/enums/serviceCode';

export const mentalhealthServiceCodes = [ServiceCode.GGZOint, ServiceCode.GGZOembl, ServiceCode.GGZBther];
